import { NgModule } from '@angular/core';
import { CreateNewCalculationComponent } from './pages/create-new-calculation/create-new-calculation.component';
import { GetCalculationComponent } from './pages/get-calculation/get-calculation.component';
import { ListCalculationsComponent } from './pages/list-calculations/list-calculations.component';
import { CalculationKeynameOptionsFactory } from './factories/calculation-keyname-options.factory';
import { CreateNewCalculationFormFactory } from './pages/create-new-calculation/create-new-calculation-form.factory';
import {
  CalculationTitleUpdateFormFactory,
} from './components/calculation-header/calculation-title-update-form.factory';
import { CalculationsApiController } from './api-controllers/calculations.api-controller';
import { CalculationFormEditingGuard } from './guards/calculation-form-editing.guard';
import { CalculationStore } from './stores/calculation.store';
import {
  Section84_1FormFactory,
} from './components/calculations/section-84_1/form/section-84_1-form/section-84_1-form.factory';
import { CalculationHeaderComponent } from './components/calculation-header/calculation-header.component';
import {
  Section84_1FormComponent,
} from './components/calculations/section-84_1/form/section-84_1-form/section-84_1-form.component';
import {
  Section84_1ShareClassResultComponent,
} from './components/calculations/section-84_1/result/section-84_1-share-class-result/section-84_1-share-class-result.component';
import {
  Section84_1ResultComponent,
} from './components/calculations/section-84_1/result/section-84_1-result/section-84_1-result.component';
import { DiscardChangesComponent } from './components/discard-changes/discard-changes.component';
import { CoreModule } from '../core/core.module';
import {
  WarningResettingToDraftComponent,
} from './components/warning-resetting-to-draft/warning-resetting-to-draft.component';
import {
  WarningResultsResettingComponent,
} from './components/warning-results-resetting/warning-results-resetting.component';
import {
  WarningCalculationInProgressComponent,
} from './components/warning-calculation-in-progress/warning-calculation-in-progress.component';
import {
  WarningArrayItemDeletionComponent,
} from './components/warning-array-item-deletion/warning-array-item-deletion.component';
import { CurrencyCentsPipe } from './pipes/currency-cents.pipe';
import { OutputVariableComponent } from './components/output-variable/output-variable.component';
import { BooleanResultPipe } from './pipes/boolean-result.pipe';
import { RolloverFormComponent } from './components/calculations/rollover/form/rollover-form/rollover-form.component';
import { RolloverFormFactory } from './components/calculations/rollover/form/rollover-form/rollover-form.factory';
import {
  RolloverResultComponent,
} from './components/calculations/rollover/result/rollover-result/rollover-result.component';
import {
  RolloverCapitalGainResultComponent,
} from './components/calculations/rollover/result/rollover-capital-gain-result/rollover-capital-gain-result.component';
import {
  RolloverRecapturedDepreciationResultComponent,
} from './components/calculations/rollover/result/rollover-recaptured-depreciation-result/rollover-recaptured-depreciation-result.component';
import {
  RolloverInventoryResultComponent,
} from './components/calculations/rollover/result/rollover-inventory-result/rollover-inventory-result.component';
import {
  RolloverDeemedDividend843ResultComponent,
} from './components/calculations/rollover/result/rollover-deemed-dividend-84-3-result/rollover-deemed-dividend-84-3-result.component';
import {
  RolloverDeemedDividend841ResultComponent,
} from './components/calculations/rollover/result/rollover-deemed-dividend-84-1-result/rollover-deemed-dividend-84-1-result.component';
import {
  RolloverPropertyTransferredResultComponent,
} from './components/calculations/rollover/result/rollover-property-transferred-result/rollover-property-transferred-result.component';
import {
  RolloverAmountToDeclareResultComponent,
} from './components/calculations/rollover/result/rollover-amount-to-declare-result/rollover-amount-to-declare-result.component';
import {
  RolloverShareCapitalResultComponent,
} from './components/calculations/rollover/result/rollover-share-capital-result/rollover-share-capital-result.component';
import {
  RolloverSection85ResultComponent,
} from './components/calculations/rollover/result/rollover-section-85-result/rollover-section-85-result.component';
import { ExportApiController } from './api-controllers/export.api-controller';
import { DeleteCalculationComponent } from './components/delete-calculation/delete-calculation.component';
import { DuplicateCalculationComponent } from './components/duplicate-calculation/duplicate-calculation.component';
import {
  RolloverPropertySection84_1FormComponent,
} from './components/calculations/rollover/form/rollover-property-section-84_1-form/rollover-property-section-84_1-form.component';
import {
  RolloverPropertyShareClassesFormComponent,
} from './components/calculations/rollover/form/rollover-property-share-classes-form/rollover-property-share-classes-form.component';
import {
  RolloverPropertyNonShareConsiderationFormComponent,
} from './components/calculations/rollover/form/rollover-property-non-share-consideration-form/rollover-property-non-share-consideration-form.component';
import {
  RolloverPropertyFormComponent,
} from './components/calculations/rollover/form/rollover-property-form/rollover-property-form.component';
import {
  RolloverPropertiesFormComponent,
} from './components/calculations/rollover/form/rollover-properties-form/rollover-properties-form.component';
import {
  RolloverShareHoldersFormComponent,
} from './components/calculations/rollover/form/rollover-share-holders-form/rollover-share-holders-form.component';
import {
  RolloverShareClassesFormComponent,
} from './components/calculations/rollover/form/rollover-share-classes-form/rollover-share-classes-form.component';
import {
  RolloverShareClassShareHolderDistributionsFormComponent,
} from './components/calculations/rollover/form/rollover-share-class-share-holder-distributions-form/rollover-share-class-share-holder-distributions-form.component';
import {
  RolloverAddNonShareConsiderationTypeModalComponent,
} from './components/calculations/rollover/form/rollover-add-non-share-consideration-type-modal/rollover-add-non-share-consideration-type-modal.component';
import {
  RolloverShareClassFormComponent,
} from './components/calculations/rollover/form/rollover-share-class-form/rollover-share-class-form.component';
import { RrqFormComponent } from './components/calculations/rrq/form/rrq-form/rrq-form.component';
import { RrqFormFactory } from './components/calculations/rrq/form/rrq-form/rrq-form.factory';
import { RrqResultComponent } from './components/calculations/rrq/result/rrq-result/rrq-result.component';
import {
  CalculationBaseFormFactory,
} from './components/calculations/base-form/form/base-form/calculation-base-form.factory';
import { CalculationsUtils } from './utils/calculations.utils';
import { NotAvailablePipe } from './pipes/not-available.pipe';
import {
  SalaryDividendFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-form/salary-dividend-form.component';
import {
  SalaryDividendPersonalTaxChildFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-personal-tax-child-form/salary-dividend-personal-tax-child-form.component';
import {
  SalaryDividendPersonalTaxChildrenFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-personal-tax-children-form/salary-dividend-personal-tax-children-form.component';
import {
  SalaryDividendPersonalTaxFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-personal-tax-form/salary-dividend-personal-tax-form.component';
import {
  SalaryDividendPersonalTaxSpouseFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-personal-tax-spouse-form/salary-dividend-personal-tax-spouse-form.component';
import {
  SalaryDividendFormFactory,
} from './components/calculations/salary-dividend/form/salary-dividend-form/salary-dividend-form.factory';
import {
  SalaryDividendCorporateTaxConnectedCorporationFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-corporate-tax-connected-corporation-form/salary-dividend-corporate-tax-connected-corporation-form.component';
import {
  SalaryDividendCorporateTaxConnectedCorporationsFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-corporate-tax-connected-corporations-form/salary-dividend-corporate-tax-connected-corporations-form.component';
import {
  SalaryDividendCorporateTaxFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-corporate-tax-form/salary-dividend-corporate-tax-form.component';
import {
  SalaryDividendPersonalTaxChildCampFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-personal-tax-child-camp-form/salary-dividend-personal-tax-child-camp-form.component';
import {
  SalaryDividendPersonalTaxChildCampsFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-personal-tax-child-camps-form/salary-dividend-personal-tax-child-camps-form.component';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import {
  ExportModalSection84_1Component,
} from './components/export-modal/export-modal-section-84_1/export-modal-section-84_1.component';
import { CalculationListComponent } from './pages/list/calculation-list.component';
import { ImportModalComponent } from './components/import-modal/import-modal.component';
import {
  SalaryDividendResultComponent,
} from './components/calculations/salary-dividend/result/salary-dividend-result/salary-dividend-result.component';
import { ImportManager } from './managers/import.manager';
import {
  WithholdingTaxFormComponent,
} from './components/calculations/salary-contributions/form/withholding-tax-form/withholding-tax-form.component';
import {
  WithholdingTaxFormFactory,
} from './components/calculations/salary-contributions/form/withholding-tax-form/withholding-tax-form.factory';
import {
  CalculationFormSidebarHeadingComponent,
} from './components/calculation-form-sidebar/calculation-form-sidebar-heading/calculation-form-sidebar-heading.component';
import { FormChangeManager } from './managers/form-change.manager';
import {
  CalculationFormSidebarComponent,
} from './components/calculation-form-sidebar/calculation-form-sidebar.component';
import { QuickCalculationManager } from './managers/quick-calculation.manager';
import {
  GrantDelegatedAccessModalComponent,
} from './components/grant-delegated-access-modal/grant-delegated-access-modal.component';
import { CalculationLifecycleManager } from './managers/calculation-lifecycle.manager';
import { ExportManager } from './managers/export.manager';
import { ExportResourceProvider } from '../core/providers/export-resource.provider';
import { Section84_1XlsxFiller } from '../../../../../../common/src/exports/xlsx-fillers/section-84_1.xlsx-filler';
import {
  SalaryDividendXlsxFiller,
} from '../../../../../../common/src/exports/xlsx-fillers/salary-dividend.xlsx-filler';
import { FileFillerFactory } from '../../../../../../common/src/exports/factories/file-filler.factory';
import { PdfFillerFactory } from '../../../../../../common/src/exports/factories/pdf-filler.factory';
import { XlsxFillerFactory } from '../../../../../../common/src/exports/factories/xlsx-filler.factory';
import { Section84_1PdfFiller } from '../../../../../../common/src/exports/pdf-fillers/section-84_1.pdf-filler';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {
  ExportModalSalaryDividendComponent,
} from './components/export-modal/salary-dividend/export-modal-salary-dividend.component';
import { ExportModalFactory } from './factories/export-modal.factory';
import {
  SalaryDividendQppPensionFormComponent,
} from './components/calculations/salary-dividend/form/salary-dividend-qpp-pension-form/salary-dividend-qpp-pension-form.component';
import {RrspFormComponent} from "./components/calculations/rrsp/form/rrsp-form/rrsp-form.component";
import {RrspPersonalTaxFormComponent} from "./components/calculations/rrsp/form/rrsp-personal-tax-form/rrsp-personal-tax-form.component";
import {RrspPersonalTaxChildCampFormComponent} from "./components/calculations/rrsp/form/rrsp-personal-tax-child-camp-form/rrsp-personal-tax-child-camp-form.component";
import {RrspPersonalTaxChildCampsFormComponent} from "./components/calculations/rrsp/form/rrsp-personal-tax-child-camps-form/rrsp-personal-tax-child-camps-form.component";
import {RrspPersonalTaxChildrenFormComponent} from "./components/calculations/rrsp/form/rrsp-personal-tax-children-form/rrsp-personal-tax-children-form.component";
import {RrspPersonalTaxChildFormComponent} from "./components/calculations/rrsp/form/rrsp-personal-tax-child-form/rrsp-personal-tax-child-form.component";
import {RrspPersonalTaxSpouseFormComponent} from "./components/calculations/rrsp/form/rrsp-personal-tax-spouse-form/rrsp-personal-tax-spouse-form.component";
import {RrspResultComponent} from "./components/calculations/rrsp/result/rrsp-result/rrsp-result.component";
import {RrspFormFactory} from "./components/calculations/rrsp/form/rrsp-form/rrsp-form.factory";
import { MagienoAdvancedFormsModule } from '@magieno/angular-advanced-forms';

@NgModule({
  declarations: [
    CreateNewCalculationComponent,
    GetCalculationComponent,
    CalculationListComponent,
    ListCalculationsComponent,

    DeleteCalculationComponent,
    DiscardChangesComponent,
    DuplicateCalculationComponent,

    CalculationHeaderComponent,

    // Rollover
    RolloverFormComponent,
    RolloverPropertySection84_1FormComponent,
    RolloverPropertyShareClassesFormComponent,
    RolloverPropertyNonShareConsiderationFormComponent,
    RolloverPropertyFormComponent,
    RolloverPropertiesFormComponent,
    RolloverShareHoldersFormComponent,
    RolloverShareClassesFormComponent,
    RolloverShareClassFormComponent,
    RolloverShareClassShareHolderDistributionsFormComponent,
    RolloverAddNonShareConsiderationTypeModalComponent,
    RolloverResultComponent,
    RolloverPropertyTransferredResultComponent,
    RolloverAmountToDeclareResultComponent,
    RolloverShareCapitalResultComponent,
    RolloverSection85ResultComponent,
    RolloverCapitalGainResultComponent,
    RolloverRecapturedDepreciationResultComponent,
    RolloverInventoryResultComponent,
    RolloverDeemedDividend843ResultComponent,
    RolloverDeemedDividend841ResultComponent,

    //RRQ
    RrqFormComponent,
    RrqResultComponent,

    WithholdingTaxFormComponent,

    // Rrsp
    RrspFormComponent,
    RrspPersonalTaxFormComponent,
    RrspPersonalTaxChildCampFormComponent,
    RrspPersonalTaxChildCampsFormComponent,
    RrspPersonalTaxChildrenFormComponent,
    RrspPersonalTaxChildFormComponent,
    RrspPersonalTaxSpouseFormComponent,
    RrspResultComponent,

    // Salary dividend
    SalaryDividendCorporateTaxConnectedCorporationFormComponent,
    SalaryDividendCorporateTaxConnectedCorporationsFormComponent,
    SalaryDividendCorporateTaxFormComponent,
    SalaryDividendFormComponent,
    SalaryDividendPersonalTaxChildCampsFormComponent,
    SalaryDividendPersonalTaxChildCampFormComponent,
    SalaryDividendPersonalTaxChildFormComponent,
    SalaryDividendPersonalTaxChildrenFormComponent,
    SalaryDividendPersonalTaxFormComponent,
    SalaryDividendPersonalTaxSpouseFormComponent,
    SalaryDividendQppPensionFormComponent,
    SalaryDividendResultComponent,

    // Section 84.1
    Section84_1FormComponent,
    Section84_1ResultComponent,
    Section84_1ShareClassResultComponent,

    // Pipes
    CurrencyCentsPipe,
    BooleanResultPipe,
    NotAvailablePipe,

    WarningResettingToDraftComponent,
    WarningResultsResettingComponent,
    WarningCalculationInProgressComponent,
    WarningArrayItemDeletionComponent,

    // Export
    ExportModalSection84_1Component,
    ExportModalSalaryDividendComponent,

    OutputVariableComponent,

    CalculationFormSidebarComponent,
    CalculationFormSidebarHeadingComponent,

    //Modals
    GrantDelegatedAccessModalComponent,
    ImportModalComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    CoreModule,
    NgbModule,
    MagienoAdvancedFormsModule,
  ],
  providers: [
    // Api Controllers
    CalculationsApiController,
    ExportApiController,

    // Factories
    CalculationBaseFormFactory,
    CalculationKeynameOptionsFactory,
    WithholdingTaxFormFactory,
    ExportModalFactory,

    // Form Services
    RolloverFormFactory,
    RrqFormFactory,
    SalaryDividendFormFactory,
    Section84_1FormFactory,
    RrspFormFactory,

    // Guards
    CalculationFormEditingGuard,

    // Managers
    CalculationLifecycleManager,
    ExportManager,
    FormChangeManager,
    ImportManager,
    QuickCalculationManager,

    // Services
    CalculationTitleUpdateFormFactory,
    CreateNewCalculationFormFactory,

    // Stores
    CalculationStore,

    // Utils
    CalculationsUtils,


    // Exports

    // Xlsx Fillers
    {
      provide: Section84_1XlsxFiller,
      useClass: Section84_1XlsxFiller,
    },
    {
      provide: SalaryDividendXlsxFiller,
      useClass: SalaryDividendXlsxFiller,
    },
    {
      provide: XlsxFillerFactory,
      deps: [Section84_1XlsxFiller, SalaryDividendXlsxFiller],
      useFactory: (section841XlsxFiller: Section84_1XlsxFiller, salaryDividendXlsxFiller: SalaryDividendXlsxFiller) => {
        return new XlsxFillerFactory(section841XlsxFiller, salaryDividendXlsxFiller);
      },
    },


    // Pdf Fillers
    {
      provide: Section84_1PdfFiller,
      deps: [ExportResourceProvider],
      useFactory: (exportResourceProvider: ExportResourceProvider) => {
        return new Section84_1PdfFiller(exportResourceProvider);
      },
    },

    {
      provide: PdfFillerFactory,
      deps: [Section84_1PdfFiller],
      useFactory: (section84PdfFiller: Section84_1PdfFiller) => {
        return new PdfFillerFactory(section84PdfFiller);
      },
    },

    {
      provide: FileFillerFactory,
      deps: [PdfFillerFactory, XlsxFillerFactory],
      useFactory: (pdfFillerFactory: PdfFillerFactory, xlsxFillerFactory: XlsxFillerFactory) => {
        return new FileFillerFactory(pdfFillerFactory, xlsxFillerFactory);
      },
    },
  ],
  exports: [
    CreateNewCalculationComponent,
    GetCalculationComponent,
    ListCalculationsComponent,

    DeleteCalculationComponent,
    DiscardChangesComponent,
    DuplicateCalculationComponent,

    CalculationHeaderComponent,

    CurrencyCentsPipe,
    BooleanResultPipe,

    // Exports
    ExportModalSection84_1Component,
    ExportModalSalaryDividendComponent,

    WithholdingTaxFormComponent,

    // Salary dividend
    SalaryDividendCorporateTaxConnectedCorporationFormComponent,
    SalaryDividendCorporateTaxConnectedCorporationsFormComponent,
    SalaryDividendCorporateTaxFormComponent,
    SalaryDividendFormComponent,
    SalaryDividendPersonalTaxChildCampsFormComponent,
    SalaryDividendPersonalTaxChildCampFormComponent,
    SalaryDividendPersonalTaxChildFormComponent,
    SalaryDividendPersonalTaxChildrenFormComponent,
    SalaryDividendPersonalTaxFormComponent,
    SalaryDividendPersonalTaxSpouseFormComponent,
    SalaryDividendResultComponent,

    // Section 84.1
    Section84_1FormComponent,
    Section84_1ResultComponent,
    Section84_1ShareClassResultComponent,

    WarningResettingToDraftComponent,
    WarningResultsResettingComponent,
    WarningCalculationInProgressComponent,
    WarningArrayItemDeletionComponent,

    OutputVariableComponent,

    // Modals
    ImportModalComponent,
  ],
})
export class CalculationsModule {
}
